import styled from "styled-components";

export const HeaderCredencial = styled.div`
    .title-header {
      text-align: left;
      margin: 10px;
    }
`

export const ContentInfo = styled.div`
    background-color: #f6f6f6;
    padding: 22px;
    border-radius: 10px;
    margin-bottom: 40px;
`;

export const FormContentCred = styled.div`
   .form-content-cred {
        display: flex;
    }
`;

export const FormContainerCredenciais = styled.div`
    margin: 20px;
    color: #858796;

    .form-content {
      display: flex;
      justify-content: center;
    }

    .form-certificate {
      display: flex;
      justify-content: space-between;
    }

    .form-content-checkbox {
      display: flex;
      justify-content: flex-start;
    }

     .form-item {
      margin: 10px;
    }

    .btns-certificate {
      display: flex;
    }

    .btn-certificate {
      background: #005a9e;
      border-radius: 8px;
      color: #fff;
      margin-left: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  .btn-save {
      background: #005a9e;
      height: 40px;
      width: 200px;
      border-radius: 8px;
      color: #fff;
    }


  
`;

export const TableCredContent = styled.div`

.position-btn{
    position: relative;
    top: 10px;
    left: 10px;
}

  .style-model{
    width: 20px;
    height: 20px;
  }

  .btn-model{
    padding: 10px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
  }

  .hover-remove:hover{
  background: #ff0000ba;
    color: #ffffff;
  }

  .hover-padrao: hover{
      background: #0361a7;
    color: #ffffff;
  }

  .key{
    width: 15px;
    height: 15px;
    font-size: 15px;
    padding: 5px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-radius: 50%;
    background: #faad14;
    color: #fff;
    position: relative;
    top: 0px;
    left: 30px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }

    .btn {
    background: #005a9e;
    border-radius: 8px;
    color: #fff;
  }

  btn-add {
    background: #fff;
  }
`;


